/**
 * 시간 문자열화 관련 유틸 함수 모듈
 * @module core/time/stringify
 */
import dayjs from 'dayjs';

/**
 * 초를 기간 문자열로 변환 (예: 3661 -> 'p1h 1m 1s')
 * @param options.totalSeconds 총 초
 * @param options.isWordP 'p' 접두사 포함 여부
 * @returns 기간 문자열
 */
export const stringifyPeriod = ({
  totalSeconds,
  isWordP = true,
}: {
  totalSeconds: number;
  isWordP?: boolean;
}): string => {
  const DAY_SECONDS = 86400;
  const HOUR_SECONDS = 3600;
  const MINUTE_SECONDS = 60;

  let remaining = totalSeconds;

  const days = Math.floor(remaining / DAY_SECONDS);
  remaining %= DAY_SECONDS;

  const hours = Math.floor(remaining / HOUR_SECONDS);
  remaining %= HOUR_SECONDS;

  const minutes = Math.floor(remaining / MINUTE_SECONDS);
  remaining %= MINUTE_SECONDS;

  const seconds = remaining;

  const parts: string[] = [`${isWordP ? 'p' : ''}`];

  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0) parts.push(`${seconds}s`);

  return parts.join('');
};

/**
 * 시간 범위에서 기간 문자열 계산
 * @param fromTimeString 시작 시간 문자열
 * @param toTimeString 종료 시간 문자열
 * @returns 기간 문자열 (예: 'p1d 2h 30m 15s')
 */
export const getTimePeriodByRange = (fromTimeString: string, toTimeString: string): string => {
  const fromTime = +dayjs(fromTimeString);
  const toTime = +dayjs(toTimeString);

  let diff = toTime - fromTime;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * (1000 * 60 * 60 * 24);

  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * (1000 * 60 * 60);

  const minutes = Math.floor(diff / (1000 * 60));
  diff -= minutes * (1000 * 60);

  const seconds = Math.floor(diff / 1000);

  const daysString = days > 0 ? `${days}d ` : '';
  const hoursString = hours > 0 ? `${hours}h ` : '';
  const minutesString = minutes > 0 ? `${minutes}m ` : '';
  const secondsString = seconds >= 0 ? `${seconds}s ` : '';

  return `p${daysString}${hoursString}${minutesString}${secondsString}`.trim();
};
